import React from 'react'
import { ReactSVG } from 'react-svg'

interface Props {
  icon: string
}

const Icon: React.FC<Props> = ({ icon }) => <ReactSVG src={icon} />

export default Icon
